import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import mission_photo from "../images/mission.jpg";



function Mission() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
         
            <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Mission <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-0"><b>Mission</b></h1>
                            <div className="col-md-2">
                            <hr style={{color:"#1D4D93"}}/>
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-9 mt-3">
                                        <div className='mission'>
                                        <p className='mb-2'>To nurture the unique potential in each child </p>
                                        <p className='justify mb-2'>To foster an environment for development of qualities of leadership, team spirit, sportsmanship, self-esteem and other challenges  </p>
                                        <p className='justify mb-2'>To prepare the children to meet the challenges of globalization galloping technology and social changes in the 21st century  </p>
                                        <p className='justify mb-2'>To make children aware of the significance of an eco-friendly environment and universal brotherhood </p>
                                        <p className='justify mb-2'>  To prescribe and implement curriculum for physical, mental, emotional, spiritual and intellectual growth of the younger generation  </p>
                                        <p className='justify mb-2'>To foster Critical Thinking and Decision-Making Skills and develop Empathy and Inclusivity amongst children  </p>
                                        </div>
                                    </div>
                                    <div className="col-md-3 mt-3">

                                        <img src={mission_photo} className="card-img-top" alt="mission_photo" />


                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <br />


        </div>
    )
}

export default Mission